import { Upload } from "lucide-react";
import { Button } from "@/core/components/ui/button";
import { Stack } from "@/core/components/ui/stack";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/core/components/ui/tooltip";
import { formatMoneyCents } from "@/core/utils/money";
import { useStAdjustmentsSection } from "./st-adjustments-section";

export const StAdjustmentsPreviewHeaderActions = () => {
  const { totals } = useStAdjustmentsSection();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Stack direction="row" className="inline-flex" tabIndex={0}>
          <Button size="sm" leftIcon={<Upload className="h-4 w-4" />} disabled>
            Push all {totals?.pending ?? 0} ·{" "}
            {formatMoneyCents(totals?.pending_amount_cents ?? 0) ?? "$0"}
          </Button>
        </Stack>
      </TooltipTrigger>
      <TooltipContent>
        Contact the Volca team to enable PushPay for your account.
      </TooltipContent>
    </Tooltip>
  );
};
